<div id="nss" class="inner-page">
  <div class="container-fluid px-lg-5">

    <h2 class="title">National Service Scheme (NSS)</h2>

    <!-- Two-column layout: PRERNA card + Content -->
    <div class="row g-4 mt-2 align-items-start">

      <!-- Left: PRERNA Dark Card -->
      <div class="col-12 col-lg-4">
        <div class="nss-prerna-card rounded-4 p-4 text-center text-white"
          style="background: #1a1a1a; border: 2px solid #444;">
          <p class="fw-bold mb-1" style="font-size: 0.85rem; letter-spacing: 1px;">SHAH SATNAM JI GIRLS' COLLEGE,</p>
          <p class="fw-bold mb-1" style="font-size: 0.85rem; letter-spacing: 1px;">SIRSA, HARYANA-125055</p>
          <p class="text-warning mb-3" style="font-size: 0.75rem; letter-spacing: 1px;">AFFILIATED TO CHAUDHARY DEVI LAL
            UNIVERSITY</p>

          <img src="assets/img/quick-links/nss/prerna-main-img.png" alt="NSS PRERNA" class="img-fluid rounded-3 mb-3"
            style="max-height: 180px; object-fit: contain;">

          <h2 class="fw-bold my-2" style="font-family: serif; letter-spacing: 4px; color: #fff;">PRERNA</h2>
          <p class="text-warning mb-1" style="font-size: 0.8rem; letter-spacing: 2px;">INSPIRED YOU AND ME</p>
          <p class="text-warning mb-3" style="font-size: 0.8rem;">(2021-2022)</p>

          <hr style="border-color: #555;">
          <p class="fw-bold text-warning mb-1" style="letter-spacing: 2px;">NATIONAL SERVICE SCHEME</p>
          <p class="text-light mb-0" style="font-size: 0.75rem; letter-spacing: 1px;">MINISTRY OF YOUTH AFFAIRS AND
            SPORTS</p>
          <p class="text-light" style="font-size: 0.75rem; letter-spacing: 1px;">GOVT. OF INDIA</p>
        </div>
      </div>

      <!-- Right: Content -->
      <div class="col-12 col-lg-8">
        <h4 class="section-subtitle">Fostering Social Responsibility and Community Engagement</h4>
        <p class="inner-lead">
          NSS Unit at Shah Satnam Ji Girls' College has been a beacon of Community Services and Social responsibility.
          Our NSS unit is dedicated to instilling the values of selfless service, leadership, and teamwork among our
          students. Over the years, it has emerged as a vital platform for students to contribute to society while
          developing their skills and character.
        </p>

        <h4 class="section-subtitle mt-4">Activities and Initiatives in the shape of Health Camps and Blood Donation
          Drives</h4>
        <p>Our NSS unit regularly organizes health camps and blood donation drives in collaboration with local hospitals
          and health organizations. These initiatives have significantly benefited the community by providing essential
          health services and creating awareness about the importance of blood donation.</p>

        <ul class="list-styled mt-3">
          <li><strong>Program Officer:</strong> Ms. Poonam Dhamija</li>
        </ul>

        <h5 class="mt-3">Members</h5>
        <ul class="list-styled">
          <li>Ms. Ruby</li>
          <li>Ms. Gurdeep</li>
          <li>Ms. Bhavya</li>
        </ul>

        <hr class="divider">

        <h4 class="section-subtitle">Message From Principal Desk</h4>
        <h5>My Felicitation to all of you —</h5>
        <p>The NSS is a central sector scheme of the Government of India, Ministry of Youth Affairs and Sports. The
          motto of NSS is "Not Me But You". NSS aims at developing in students an insight to identify and tackle the
          problems and needs of the society. This builds up a democratic attitude in students and brings out the quality
          of leadership and encourages them to offer 'selfless service' towards humanity. The NSS units of the college
          holds various awareness programs to work for eradication of illiteracy, voluntary health service camps,
          communal harmony and environment awareness camps. The National Service Scheme Camp of 7 days is organised
          every year which is attended by at least 50% of volunteers. It provides a chance to develop the overall
          personality of the student volunteers. To inculcate a sense of social responsibility, the NSS unit of the
          college organises visits to old age home, orphanage, slum areas and the adopted Villages.</p>

        <h4 class="section-subtitle mt-4">Social Responsibilities</h4>
        <p>Shah Satnam Ji Girls' College Sirsa, has always taken initiatives for improving the quality of lives of the
          Community around it; be it through impartment of value education to its students or through other social
          development initiatives. In fact, it has always made pro-active efforts to address the relevant issues in the
          Society.</p>
      </div>
    </div>

    <hr class="divider mt-5">

    <h4 class="section-subtitle">NSS Activity Reports</h4>
    <div class="row g-3 mt-2">
      <div class="col-md-4">
        <a href="/assets/pdf/campus-life/NSS-Activities-2023-23.pdf" target="_blank"
          class="pdf-download-btn w-100 text-center">
          <i class="fa fa-file-pdf-o me-2"></i>NSS Activities 2023-24
        </a>
      </div>
      <div class="col-md-4">
        <a href="/assets/pdf/campus-life/NSS-Activities-2022-23.pdf" target="_blank"
          class="pdf-download-btn w-100 text-center">
          <i class="fa fa-file-pdf-o me-2"></i>NSS Activities 2022-23
        </a>
      </div>
      <div class="col-md-4">
        <a href="/assets/pdf/campus-life/NSS-Activities-2021-22.pdf" target="_blank"
          class="pdf-download-btn w-100 text-center">
          <i class="fa fa-file-pdf-o me-2"></i>NSS Activities 2021-22
        </a>
      </div>
    </div>

    <hr class="divider mt-5">

    <h4 class="section-subtitle">Photo Gallery</h4>
    <div class="row g-3 mt-2 mb-4">
      <div class="col-6 col-md-3" *ngFor="let img of nssImages">
        <div class="rounded-4 overflow-hidden shadow-sm border border-2 border-white">
          <img [src]="img" alt="NSS Activity" class="img-fluid w-100" style="object-fit: cover; height: 180px;">
        </div>
      </div>
    </div>

  </div>
</div>